import {Routes, Route, Navigate} from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import ProductCategory from "./pages/ProductCategory";
import ProductList from "./pages/ProductList";
import ProductSell from "./pages/ProductSell";
import ReportOrder from "./pages/ReportOrder";
import ReportTransaction from "./pages/ReportTransaction";
import CustomerSingle from "./pages/CustomerSingle";
import Customers from "./pages/Customers";
import Presensi from "./pages/Presensi";
import Employee from "./pages/Employee";
import EmployeeSingle from "./pages/EmployeeSingle";
import SettingAdmin from "./pages/SettingAdmin";
import SettingLogLogin from "./pages/SettingLogLogin";
import Navbar from "./components/Navbar";
import Sidebar from "./components/Sidebar";
import {useEffect, useState} from "react";
import CashierSingle from "./pages/CashierSingle";
import Jobs from "./pages/Jobs";
import ReportCommission from "./pages/ReportCommission";
import CashierInput from "./pages/CashierInput";
import {getRole} from "./Session";
import ProductActivity from "./pages/ProductActivity";
import PaymentMethod from "./pages/PaymentMethod";
import ModalLogout from "./components/ModalLogout";
import EmployeePresence from "./pages/EmployeePresence";

function App() {
  const [width, setWidth] = useState(window.innerWidth);
  const [displaySidebar, setDisplaySidebar] = useState(false);

  // Modal
  const [modalLogout, setModalLogout] = useState(false);

  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth);
    if (window.innerWidth < 1024) {
      if (displaySidebar) {
        setDisplaySidebar(false);
      }
    } else {
      setDisplaySidebar(true);
    }
  };

  useEffect(() => {
    handleWindowSizeChange();
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, [width]);

  const toggleSidebar = () => {
    return setDisplaySidebar(!displaySidebar);
  };

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("task");
    localStorage.removeItem("cart");
    setModalLogout(false);
    window.location = "/login";
  };

  return (
    <>
      {localStorage.getItem("user") && localStorage.getItem("token") ? (
        <div className="flex flex-col bg-black h-screen">
          <ModalLogout
            show={modalLogout}
            close={() => setModalLogout(false)}
            logout={handleLogout}
          />
          <Navbar
            toggleSidebar={toggleSidebar}
            handleLogout={() => setModalLogout(true)}
          />
          <div className="flex flex-row h-full mt-20 overflow-hidden">
            <Sidebar show={displaySidebar} setHide={toggleSidebar} />
            <div className="overflow-y-auto p-2 w-full text-white scrollbar-shown">
              <Routes>
                {getRole() === "admin" ? (
                  <>
                    <Route path="cashier">
                      <Route
                        path="/cashier"
                        element={<Navigate to="/cashier/input" replace />}
                      />
                      <Route path="input" element={<CashierInput />} />
                      <Route path="confirmation" element={<CashierSingle />} />
                    </Route>
                    <Route
                      path="*"
                      element={<Navigate to="/cashier/input" replace />}
                    />
                  </>
                ) : (
                  <Route path="/">
                    <Route index element={<Dashboard />} />
                    <Route path="cashier">
                      <Route
                        path="/cashier"
                        element={<Navigate to="/cashier/input" replace />}
                      />
                      <Route path="input" element={<CashierInput />} />
                      <Route path="confirmation" element={<CashierSingle />} />
                    </Route>
                    <Route path="product">
                      <Route
                        path="/product"
                        element={<Navigate to="/product/category" replace />}
                      />
                      <Route path="category" element={<ProductCategory />} />
                      <Route path="list" element={<ProductList />} />
                      <Route path="sell" element={<ProductSell />} />
                      <Route
                        path="/product/commission"
                        element={<ProductActivity />}
                      />
                    </Route>
                    <Route path="report">
                      <Route
                        path="/report"
                        element={<Navigate to="/report/order" replace />}
                      />
                      <Route path="order" element={<ReportOrder />} />
                      <Route
                        path="transaction"
                        element={<ReportTransaction />}
                      />
                      <Route path="commission" element={<ReportCommission />} />
                    </Route>
                    <Route path="payment-method">
                      <Route index element={<PaymentMethod />} />
                    </Route>
                    <Route path="customers">
                      <Route index element={<Customers />} />
                      {/* <Route path=":customerId" element={<CustomerSingle />} /> */}
                    </Route>
                    <Route path="presensi" element={<Presensi />} />
                    <Route path="employee">
                      <Route
                        path="/employee"
                        element={<Navigate to="/employee/list" replace />}
                      />
                      <Route path="jobs" element={<Jobs />} />
                      <Route path="list">
                        <Route index element={<Employee />} />
                        <Route
                          path="/employee/list/detail"
                          element={<EmployeeSingle />}
                        />
                      </Route>
                      <Route
                        path="/employee/presence"
                        element={<EmployeePresence />}
                      />
                    </Route>
                    <Route path="setting">
                      <Route
                        path="/setting"
                        element={<Navigate to="/setting/admin" replace />}
                      />
                      <Route path="admin" element={<SettingAdmin />} />
                      <Route path="log" element={<SettingLogLogin />} />
                    </Route>
                  </Route>
                )}
                <Route path="/login" element={<Navigate to="/" replace />} />
                {getRole() === "admin" ? (
                  <Route
                    path="*"
                    element={<Navigate to="/cashier/input" replace />}
                  />
                ) : (
                  <Route path="*" element={<Navigate to="/" replace />} />
                )}
              </Routes>
            </div>
          </div>
        </div>
      ) : (
        <Routes>
          <Route path="/">
            <Route index element={<Login />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      )}
    </>
  );
}

export default App;
